export const UUID_SUCCESS = "UUID_SUCCESS";

export const uuidThemeAction = (data) => {
  return (dispatch) => {
    dispatch({ type: "UUID_SUCCESS", data });
  };
};

const initialState = {
  uuidThemeValue: "",
};

export default function uuidThemeReducer(state = initialState, action) {
  switch (action.type) {
    case UUID_SUCCESS:
      return {
        ...state,
        uuidThemeValue: action.data,
      };
    default:
      return state;
  }
}
